import { MetricCard } from './MetricCard'

interface IActiveBotsCard {
  metric: string
}

export const ActiveBotsCard = ({ metric }: IActiveBotsCard) => {
  return <MetricCard title="Active Bots" metric={metric} icon="smart-toy" />
}
